<template>
        <b-modal :title="caption" class="modal-info" v-model="dataShow" @ok="confirmDuplicate" :ok-title="Core.Definition.getDefinition('Dupliquer')" ok-variant="primary" :cancel-title="Core.Definition.getDefinition('Annuler')" cancel-variant="light">
            <Request
                    ref="request"
                    method="PUT"
                    :root="root"
                    :onRequestSuccess="requestSuccess"
                    :onRequestError="requestError">
                <slot slot="body">
                    <p>
                        {{message}}
                    </p>
                </slot>
            </Request>
        </b-modal>
</template>

<script>
    import Request from './Request'
  export default {
      name: 'ModalDuplicate',
      components: {
          Request
      },
      props: {
          caption: {
              type: String,
              default: ''
          },
          message: {
              type: String,
              default: ''
          },
          root: {
              type: String,
              default: ''
          }
      },
      watch: {
      },
      mounted() {
      },
      data: () => {
          return {
              Core: window.Core,
              dataShow: false,
              dataId: '',
              dataAlert: {
                  message: '',
                  variant: '',
                  show: false
              }
          }
      },
      methods: {
          open(id) {
              this.dataId = id
              this.dataShow = true
          },
          confirmDuplicate(e) {
              e.preventDefault()
              this.$refs.request.clearArgs()
              this.$refs.request.addArg('id', this.dataId)
              this.$refs.request.request()
          },
          requestSuccess(data) {
              if (data.alert !== undefined) {
                  this.dataAlert = data.alert
              } else {
                  this.$refs.request.clearArgs()
                  this.$emit('onDuplicateSuccess',this.dataId)
                  this.dataShow = false
              }
          },
          requestError() {

          }
      }
  }
</script>